import React, {useContext, useEffect, useState} from 'react';
import EditTask from '../../api/task/edit_tasks';
import './task_detail.css';
import GetAllUser from '../../api/user/get_all_user';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { Menu, MenuItem, Button, Fade, Typography } from '@material-ui/core';
import Loader from '../loader/loader';
import AlertDialog from '../alert dialog/dialog';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Checkbox, ListItem, List } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { AuthorizationContext } from '../../context/authorizationContext';

const TaskDetail = (props)=>{

    const { userDetail } = useContext(AuthorizationContext);

    const [task_detail, setTaskDetail] = useState(props?.task);
    const [all_user, setAllUser] = useState([]);
    const [status, setStatus] = useState(props?.task?.status);
    const all_status = userDetail?.admin === true ? ["Not Started", "Development", "Error", "Reference", "Completed"] : ["Not Started", "Development", "Error", "Reference", "Review"]
    const [selected_user, setSelectedUser] = useState(props?.task?.assigned);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [visible_loader, setVisibleLoader] = useState(false);
    const [visible_dialog, setVisibleDialog] = useState(false);
    const [title_dialog, setTitleDialog] = useState("");
    const [button_dialog, setButtonDialog] = useState("");
    const [disableAllInput, setDisableAllInput] = useState(false);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    console.log("Printing checklist", task_detail);

    const ChangeOptionAddUser = ()=>{
        selected_user.map((assigned)=>{
            if(all_user.length > 0){
                all_user.map((all, index)=>{
                    if(index > -1 && all === assigned){
                        all_user.splice(index, 1);
                    }
                })
            }
        })
        // console.log(selected_user, all_user);
    };

    const EditTaskDetail = ()=>{
        setVisibleLoader(true);
        EditTask(task_detail, (res)=>{
            // console.log("Printing response in task_detail.jsx", res);
            if(res.data.status){
                setVisibleLoader(false);
                // console.log("Status true");
                setTitleDialog("Task updated successfully.!");
                setButtonDialog("Ok");
                setVisibleDialog(true);
            }
            else{
                // console.log("Status is false");
                setVisibleLoader(false);
                setTitleDialog(res.data.data);
                setButtonDialog("Ok");
                setVisibleDialog(true);
            }
        }, (err)=>{
            // console.log("Error while updating task detail", err);
            console.log("e edit");
        })
    };

    useEffect(()=>{
        setVisibleLoader(true);
        GetAllUser({}, (res)=>{
            setVisibleLoader(false);
            console.log("Printing response in task_detail", res);
            if(res.data.status){
                const all_user_temp_arr = new Array();
                res.data.data.map((v)=>{
                    all_user_temp_arr.push(v.email);
                });
                setAllUser(all_user_temp_arr);
                ChangeOptionAddUser();
            }
            else{
                console.log("Status is false");
            }
        }, (err)=>{
            console.log("Error while getting data from get all user in task_detail",err);
        })
        if(window.location.pathname === "/history"){
            setDisableAllInput(true);
        }
    }, [])

    return (
        props?.visible === true &&
        <>
            {visible_loader === true && <Loader />}
            <AlertDialog visible={visible_dialog} title={title_dialog} button={button_dialog} close={()=>{
                setVisibleDialog(false);
                window.location.reload();
            }} />
            <div className="task_detail">
                
                <input disabled={disableAllInput} type="text" className="title" value={task_detail.title} onChange={(e)=>setTaskDetail({...task_detail, title: e.target.value})} />

                <textarea disabled={disableAllInput} onChange={(e)=>setTaskDetail({...task_detail, description: e.target.value})} value={task_detail.description} className="description"></textarea>
                
                <div className="assign-user">
                <Autocomplete
                    disableClearable
                    disabled={disableAllInput}
                    onChange={(event, value)=>{
                        console.log(value);
                        setSelectedUser(value);
                        setTaskDetail({...task_detail, assigned: value});
                        // ChangeOptionAddUser();
                    }}
                    multiple
                    id="add-user"
                    options={all_user}
                    getOptionLabel={(option) => option}
                    defaultValue={selected_user}
                    // filterOptions={(all_user, state)=>{return all_user;}}
                    filterSelectedOptions
                    renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Add user"
                    />
                    )}
                />
                </div>

                {task_detail?.dueDate !== undefined && <div className="due_date">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            
                            inputFormat='dd/MM/yyyy'
                            label="Due Date"
                            value={task_detail.dueDate}
                            onChange={(value)=>{
                                if(disableAllInput === false){
                                    setTaskDetail({
                                        ...task_detail,
                                        dueDate: value
                                    })
                                }
                            }}

                            renderInput={params=>{
                                return <TextField disabled={disableAllInput} {...params} />
                            }}
                        />
                    </LocalizationProvider>
                </div>}

                {task_detail?.checkList.length >0 && <div className='checklist'>
                    <List>{
                        task_detail?.checkList?.map((obj, i)=>{
                            return <ListItem>
                                <Checkbox disabled={disableAllInput} checked={obj.checked} onChange={(e)=>{
                                    let temp = [...task_detail?.checkList];
                                    temp = temp.filter((obj, index)=>{
                                        if(index === i){
                                            obj.checked = e.target.checked;
                                        }
                                        return obj;
                                    })
                                    setTaskDetail({
                                        ...task_detail,
                                        checkList: temp
                                    })
                                }} />
                                <TextField value={obj.label} disabled={disableAllInput} placeholder={"Click here to edit..."} onChange={e => {
                                    let temp = [...task_detail?.checkList];
                                    temp = temp.filter((obj, index)=>{
                                        if(index === i){
                                            obj.label = e.target.value;
                                        }
                                        return obj;
                                    })
                                    setTaskDetail({
                                        ...task_detail,
                                        checkList: temp
                                    })
                                }} />
                                <DeleteIcon onClick={()=>{
                                    if(disableAllInput === false){
                                        let temp = [...task_detail?.checkList];
                                        temp = temp.filter((obj, index)=>{
                                            if(index !== i){
                                                return obj;
                                            }
                                        })
                                        setTaskDetail({
                                            ...task_detail,
                                            checkList: temp
                                        })
                                    }
                                }} />
                            </ListItem>
                        })
                    }</List>
                </div>}

                <div className="status" style={{display: 'flex'}}>
                    {
                        status === "Not Started" && <Button style={{textTransform: "capitalize", fontSize: "18px", backgroundColor: "#16a085", color: "#fff"}}>{status}</Button>
                    }
                    {
                        status === "Development" && <Button style={{textTransform: "capitalize", fontSize: "18px", backgroundColor: "#e67e22", color: '#fff'}}>{status}</Button>
                    }
                    {
                        status === "Error" && <Button style={{textTransform: "capitalize", fontSize: "18px", backgroundColor: "#e74c3c", color: '#fff'}}>{status}</Button>
                    }
                    {
                        status === "QC" && <Button style={{textTransform: "capitalize", fontSize: "18px", backgroundColor: "#2980b9", color: '#fff'}}>{status}</Button>
                    }
                    {
                        status === "Reference" && <Button style={{textTransform: "capitalize", fontSize: "18px", backgroundColor: "#34495e", color: '#fff'}}>{status}</Button>
                    }
                    {
                        status === "Review" && <Button style={{textTransform: "capitalize", fontSize: "18px", backgroundColor: "#27ae60", color: '#fff'}}>{status}</Button>
                    }
                    {
                        status === "Completed" && <Button style={{textTransform: "capitalize", fontSize: "18px", backgroundColor: "#27ae60", color: '#fff'}}>{status}</Button>
                    }
                    {(status === "Completed" && userDetail?.admin === false) ? null : <Button disabled={disableAllInput} id="change-status" aria-controls="fade-menu" aria-haspopup="true" onClick={handleClick}>
                        Change Status
                    </Button>}
                    <Menu
                        id="fade-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={open}
                        onClose={()=>setAnchorEl(null)}
                        TransitionComponent={Fade}
                    >
                        {all_status.map((v)=>{
                            return <MenuItem onClick={()=>{
                                setStatus(v);
                                setTaskDetail({...task_detail, status: v})
                                setAnchorEl(null);
                            }}>{v}</MenuItem>
                        })}
                    </Menu>
                </div>

                <button id="save-btn" onClick={EditTaskDetail}>Save</button>
            </div>
        </>
    )
};

export default TaskDetail;